import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDatabase,
  faCalendarAlt,
  faSpinner,
  faExclamationTriangle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import './DataSourceSelector.scss';

const DataSourceSelector = ({ onDataSourceChange, currentDataSource, isLoading, error, lastUpdated }) => {
  const [icsUrl, setIcsUrl] = useState('https://php-proxy.ivia.ch/ivia-timer/index.php');
  const [showUrlInput, setShowUrlInput] = useState(false);

  const handleSourceChange = (sourceType) => {
    if (sourceType === 'ics') {
      setShowUrlInput(true);
    } else {
      setShowUrlInput(false);
      onDataSourceChange(sourceType);
    }
  };

  const handleIcsLoad = () => {
    if (icsUrl.trim()) {
      onDataSourceChange('ics', icsUrl.trim());
      setShowUrlInput(false);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith('.ics')) {
      onDataSourceChange('file', file);
    }
    event.target.value = ''; // Reset file input
  };

  const testWithSampleData = () => {
    // Use sample data directly to avoid CORS issues
    onDataSourceChange('sample');
  };

  return (
    <div className="data-source-selector">
      <h3>Data Source</h3>

      <div className="source-options">
        <button
          className={`source-btn ${currentDataSource === 'json' ? 'active' : ''}`}
          onClick={() => handleSourceChange('json')}
          disabled={isLoading}
        >
          <FontAwesomeIcon icon={faDatabase} />
          JSON Schedule
        </button>

        <button
          className={`source-btn ${currentDataSource === 'ics' ? 'active' : ''}`}
          onClick={() => handleSourceChange('ics')}
          disabled={isLoading}
        >
          <FontAwesomeIcon icon={faCalendarAlt} />
          ICS Calendar
        </button>

        <label className="source-btn file-upload">
          <FontAwesomeIcon icon={faCalendarAlt} />
          Upload ICS File
          <input
            type="file"
            accept=".ics"
            onChange={handleFileUpload}
            disabled={isLoading}
            style={{ display: 'none' }}
          />
        </label>

        <button className="source-btn test-sample" onClick={testWithSampleData} disabled={isLoading}>
          <FontAwesomeIcon icon={faCalendarAlt} />
          Test Lab Retreat
        </button>
      </div>

      {showUrlInput && (
        <div className="ics-url-input">
          <input
            type="url"
            value={icsUrl}
            onChange={(e) => setIcsUrl(e.target.value)}
            placeholder="Enter ICS calendar URL..."
            disabled={isLoading}
          />
          <button onClick={handleIcsLoad} disabled={isLoading || !icsUrl.trim()} className="load-btn">
            Load Calendar
          </button>
          <button onClick={testWithSampleData} disabled={isLoading} className="test-btn">
            Test Sample
          </button>
        </div>
      )}

      <div className="status-indicator">
        {isLoading && (
          <div className="status loading">
            <FontAwesomeIcon icon={faSpinner} spin />
            Loading schedule data...
          </div>
        )}

        {error && (
          <div className="status error">
            <FontAwesomeIcon icon={faExclamationTriangle} />
            {error}
          </div>
        )}

        {!isLoading && !error && lastUpdated && (
          <div className="status success">
            <FontAwesomeIcon icon={faCheckCircle} />
            Last updated: {lastUpdated.toLocaleTimeString()}
          </div>
        )}
      </div>
    </div>
  );
};

export default DataSourceSelector;
